import { createStore, applyMiddleware, combineReducers, compose } from "redux";
import thunk from "redux-thunk";
import { candidateDetails } from "../reducers/candidateReducer";
import { onBoardingDetails } from "../reducers/onBoardingReducer";

const rootReducer = combineReducers({ candidateDetails, onBoardingDetails });
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);
export default store;
